module.exports = __webpack_public_path__ + "static/some_time_later.f879fdba.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/some_time_later.otf
// module id = 200
// module chunks = 89649133384338 107818501498521